import {
    ChangeDetectorRef,
    Component,
    HostBinding,
    Inject,
    OnDestroy,
    OnInit,
} from '@angular/core';
import {
    AbstractControl,
    UntypedFormBuilder,
    UntypedFormControl,
    UntypedFormGroup,
    Validators,
} from '@angular/forms';
import { HelperService, IdentifierService } from 'merlin-core';
import { EnrollPatientDeviceDataService } from '../../../../services/enroll-patient-device-data.service';
import { CountryCdEnum, PhoneCdEnum, SpinnerService, UserService } from 'merlin-library';
import { ToastrService } from 'ngx-toastr';
import { EmergencyContactModel } from '../../../../models/enroll-patient-device-data.model';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FrontEndErrMsgs } from '../../../../enums/patient-device-data.enum';
import {
    LocalizationService,
    ReturnType,
} from 'src/core/utilitites/localization.service';
import { switchMap, tap } from 'rxjs/operators';
import { LookupService } from 'projects/clinician/src/app/clinic-admin/services/lookup.service';
import { FormSecurityValidationService } from 'src/core/utilitites/form-security-validation.service';
import { GlobalInputSecurityService } from 'src/core/utilitites/global-input-security.service';

export const isControlRequired = (control: AbstractControl): boolean => {
    if (!control) {
        return false;
    }

    if (control.validator) {
        const validator = control.validator({} as AbstractControl);
        if (validator && validator.required) {
            if (!control.value || control.value === '') {
                return true;
            } else if (control.status === 'INVALID') {
                return true;
            } else {
                return false;
            }
        }
    }

    return false;
};

@Component({
    selector: 'app-emergency-contact-popup',
    templateUrl: './emergency-contact-popup.component.html',
    styleUrls: ['./emergency-contact-popup.component.scss'],
    standalone: false
})
export class EmergencyContactPopup implements OnInit, OnDestroy {
    public emergencyForm: UntypedFormGroup;
    public phoneGrp: UntypedFormGroup;
    public isAltFlag = false;
    public togglePhone = false;
    public dropdowns;
    public patientId = null;
    emergencyContact: EmergencyContactModel = {
        address: null,
        deviceType: '',
        dropdowns: null,
        firstName: '',
        lastName: '',
        notifyEmergencyContactFlg: false,
        patientId: null,
        phone: null,
    };
    public errorMsgsReq = [];
    public errorMsgsInvalid = [];
    public isError = false;
    public errorHeading;
    patientName;
    userInfo;
    dataLoaded: boolean = false;
    patientIdForTitle: string;
    isSelectedUSACountry: boolean;
    isAPIFetched: boolean = false;
    MAX_LENGTH_30 = 30;
    MAX_LENGTH_9 = 9;
    countryList: any;
    @HostBinding('class.emergencyContactWrapper') get wrapperClass() {
        return true;
    }
    @HostBinding('class.show') get valid() {
        return this.dataLoaded == true;
    }
    constructor(
        private fb: UntypedFormBuilder,
        private helperService: HelperService,
        private spinnerSer: SpinnerService,
        private service: EnrollPatientDeviceDataService,
        private dialog: MatDialog,
        private toasterService: ToastrService,
        private localizationService: LocalizationService,
        private userService: UserService,
        public identifierService: IdentifierService,
        public lookupService: LookupService,
        private formSecurity: FormSecurityValidationService,
        private globalInputSecurity: GlobalInputSecurityService,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            mode: string;
            showPhysicianOpt: boolean;
            functionMode: string;
            countryCd: number;
            emerShowPhysicianOpt: boolean;
        }
    ) {}

    ngOnInit() {
        this.isSelectedUSACountry = this.data?.countryCd === CountryCdEnum.USA;
        this.buildForm();
        this.loadData();
        this.getPatientDetails();
        this.phoneGrp.get('countryCode').valueChanges.subscribe(res=>{
            if (parseInt(res) == PhoneCdEnum.US) {
                this.phoneGrp.get('areaCode').setValidators([Validators.maxLength(3), Validators.pattern(`^[0-9-,(), ' ', ., +]*$`)]);
            } else {
                this.phoneGrp.get('areaCode').setValidators([Validators.maxLength(5), Validators.pattern(`^[0-9-,(), ' ', ., +]*$`)])
            }
        })
    }

    ngOnDestroy(): void {
        this.globalInputSecurity.dismissXssToasts();
    }
    viewMode() {
        return this.data.mode === 'view';
    }
    buildForm() {
        this.emergencyForm = this.fb.group({
            firstName: new UntypedFormControl('', Validators.compose([Validators.maxLength(this.MAX_LENGTH_30)])),
            notifyEmergencyContactFlg: new UntypedFormControl(false),
            lastName: new UntypedFormControl('', Validators.compose([Validators.maxLength(this.MAX_LENGTH_30)])),
            address: new UntypedFormControl(''),
            address2: new UntypedFormControl(''),
            address3: new UntypedFormControl(''),
            countryCd: new UntypedFormControl(this.data?.countryCd),
            stateCd: new UntypedFormControl(''),
            state: new UntypedFormControl('', Validators.compose([Validators.maxLength(this.MAX_LENGTH_30)])),
            city: new UntypedFormControl('', Validators.compose([Validators.maxLength(this.MAX_LENGTH_30)])),
            zipCode: new UntypedFormControl('', Validators.compose([Validators.maxLength(this.MAX_LENGTH_30)])),
            phone: this.generatePhone(),
        });
        this.emergencyForm
            .get('countryCd')
            .valueChanges.subscribe((country) => {
                this.isSelectedUSACountry = String(country) === '140';
            });
    }
    generatePhone() {
        return (this.phoneGrp = this.fb.group({
            countryCode: new UntypedFormControl('', [
                Validators.pattern(`^[0-9-,(), ' ', ., +]*$`), //$,#,&,@,
                Validators.maxLength(3),
            ]),
            areaCode: new UntypedFormControl('', [
                Validators.pattern(`^[0-9-,(), ' ', ., +]*$`), //$,#,&,@,
                Validators.maxLength(5),
            ]),
            number: new UntypedFormControl('', [
                Validators.pattern(`^[0-9-,(), ' ', ., +]*$`), //$,#,&,@,
                Validators.minLength(3),
                Validators.maxLength(12),
            ]),
        }));
    }
    loadData() {
        this.patientId = this.service.patientId;
        if (typeof this.patientId === 'object') {
            this.patientId.subscribe((pId) => {
                this.patientId = pId;

                if (this.patientId) {
                    this.processRequest();
                }
            });
        } else this.processRequest();
         if (this.viewMode()) {
            this.emergencyForm.disable();
        }else{
            this.emergencyForm.enable();
        }
    }

    processRequest() {
        if (!this.isAPIFetched) {
            this.service
                .getEmergencyContactDetails(this.patientId, this.data.countryCd)
                .subscribe(
                    (res) => {
                        this.emergencyContact = res;
                        this.sortCountryList(res);
                        this.isSelectedUSACountry =
                            String(res.address.countryCd) === '140';
                            this.emergencyContact = {
                                ...this.emergencyContact,
                                address : {
                                    ...this.emergencyContact.address,
                                    zipCode : this.isSelectedUSACountry && this.emergencyContact.address?.zipCode?.length === 9
                                    ? this.emergencyContact.address?.zipCode?.replace(/(\d{5})(\d{4})/, "$1-$2")
                                    : this.emergencyContact.address?.zipCode
                                }
                            }
                        setTimeout(() => {
                            this.assignValuesToForm();
                        }, 1000);
                        this.isAPIFetched = true;
                    },
                    (err) => {
                        this.service.showEmergencyContactPopup.next(false);
                        this.dataLoaded = true;
                    }
                );
        }
    }
    sortCountryList(res: any) {
       let countryListUnSort =  res?.dropdowns?.countryCodes?.map(
            (countryCode) => {
                let c = this.translate(
                    'data.Code.' +
                        countryCode.qualifier +
                        '.Code_Desc.' +
                        countryCode.code
                );
                let Cobj = {
                    ...countryCode,
                    label: c,
                    txKey:'data.Code.' +
                    countryCode.qualifier +
                    '.Code_Desc.' +
                    countryCode.code
                };
                return Cobj;
            }
        );
        this.countryList = this.sortObject(countryListUnSort);
    }
    sortObject(value) {
        return value.sort((a, b) => {
            const nameA = this.localizationService.generateLocalizedStr(
                a.label
            );
            const nameB = this.localizationService.generateLocalizedStr(
                b.label
            );
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }

            return 0;
        });
    }
    close() {
        this.globalInputSecurity.dismissXssToasts();
        this.service.showEmergencyContactPopup.next(false);
        this.dialog.closeAll();
    }

    assignValuesToForm() {
        this.emergencyForm.patchValue({
            firstName: this.emergencyContact?.firstName,
            lastName: this.emergencyContact.lastName,
            address: this.emergencyContact?.address.address,
            address2: this.emergencyContact?.address.address2,
            address3: this.emergencyContact?.address?.address3,
            countryCd: this.emergencyContact?.address.countryCd,
            stateCd: this.emergencyContact?.address.stateCd,
            state: this.emergencyContact?.address.state,
            city: this.emergencyContact?.address?.city,
            zipCode: this.emergencyContact.address?.zipCode,
            phone: {
                areaCode: this.emergencyContact.phone.areaCode,
                countryCode: this.emergencyContact.phone.countryCode,
                number: this.emergencyContact.phone.phoneNum,
            },
            notifyEmergencyContactFlg:
                this.emergencyContact.notifyEmergencyContactFlg,
        });
        if (this.viewMode()) {
            this.emergencyForm.disable();
        }
        this.dataLoaded = true;
    }

    compareCountry(o1, o2) {
        return o1 == o2;
    }

    submit() {
        this.isError = false;
        this.errorHeading = null;
        this.errorMsgsReq = [];
        this.errorMsgsInvalid = [];
        this.emergencyForm.markAllAsTouched();

        this.phoneGrp.get('areaCode').setErrors({incorrect: null});
        this.phoneGrp.get('countryCode').setErrors({incorrect: null});
        this.phoneGrp.get('number').setErrors({incorrect: null});

        this.phoneGrp.get('areaCode').updateValueAndValidity();
        this.phoneGrp.get('countryCode').updateValueAndValidity();
        this.phoneGrp.get('number').updateValueAndValidity();

        const areCode = this.phoneGrp?.get('areaCode')?.value; //?.replace(/[^0-9]/g, '');
        const countryCode = this.phoneGrp
            ?.get('countryCode')
            ?.value;// ?.replace(/[^0-9]/g, '');
        const number = this.phoneGrp?.get('number')?.value; //?.replace(/[^0-9]/g, '');
        this.phoneGrp.get('areaCode').setValue(areCode);
        this.phoneGrp.get('countryCode').setValue(countryCode);
        this.phoneGrp.get('number').setValue(number);

        if(this.phoneGrp.get('areaCode').value
            || this.phoneGrp.get('countryCode').value
            || this.phoneGrp.get('number').value)
        {
            this.phoneGrp.get('countryCode').setValidators([Validators.pattern("^[0-9-,(), ' ', ., +]*$"), Validators.required]); //$,#,&,@,
            this.phoneGrp.get('areaCode').setValidators([Validators.pattern("^[0-9-,(), ' ', ., +]*$")])  //$,#,&,@,
            this.phoneGrp.get('number').setValidators([Validators.pattern("^[0-9-,(), ' ', ., +]*$"), Validators.required]) //$,#,&,@,
        }else{
            this.phoneGrp.get('countryCode').setValidators([Validators.pattern(`^[0-9-,(), ' ', ., +]*$`)]); //$,#,&,@,
            this.phoneGrp.get('areaCode').setValidators([Validators.pattern("^[0-9-,(), ' ', ., +]*$")]) //$,#,&,@,
            this.phoneGrp.get('number').setValidators([Validators.pattern("^[0-9-,(), ' ', ., +]*$")]) //$,#,&,@,
        }
        this.phoneGrp.get('areaCode').updateValueAndValidity();
        this.phoneGrp.get('countryCode').updateValueAndValidity();
        this.phoneGrp.get('number').updateValueAndValidity();

        if (this.emergencyForm.invalid) {
            let errFields= [];
            if(this.phoneGrp.invalid){
                let errFieldsPhn = this.helperService.checkAllFormFields(
                    this.phoneGrp
                );
                const showErrIncorret = errFieldsPhn.some(
                    (err) => err.keyError === 'incorrect' || err.keyError === 'pattern'
                );
                let cCode = this.phoneGrp.get('countryCode');
                let aCode = this.phoneGrp.get('areaCode');
                let number =this.phoneGrp.get('number');
                if (!showErrIncorret && errFieldsPhn.length >= 1) {
                    if ((!number.value  || !aCode.value)) {
                        aCode.setErrors(null);
                        cCode.setErrors(null);
                        number.setErrors(null);
                        errFields =[];
                        this.phoneGrp.updateValueAndValidity();
                    } else {
                        errFields =[{key: 'homePhone', keyError: 'required'}];
                        cCode.setErrors({required: true});
                        aCode.setErrors({required: true});
                        number.setErrors({required: true});
                    }

                } else {
                errFields =[{key: 'homePhone', keyError: 'pattern'}];
                    aCode.setErrors({incorrect: true});
                    cCode.setErrors({incorrect: false});
                    number.setErrors({incorrect: true});

                }

           }
        //    if (!this.togglePhone || this.togglePhone == null) {
        //     if(this.phoneGrp.get('countryCode').value || this.phoneGrp.get('number').value || this.phoneGrp.get('areaCode').value) {
        //         errFields =[{key: 'homePhone', keyError: 'pattern'}];
        //         this.phoneGrp.get('areaCode').setErrors({incorrect: true});
        //         this.phoneGrp.get('countryCode').setErrors({incorrect: false});
        //         this.phoneGrp.get('number').setErrors({incorrect: true});
        //         this.phoneGrp.updateValueAndValidity();

        //     } else {
        //         this.phoneGrp.get('areaCode').setErrors(null);
        //         this.phoneGrp.get('countryCode').setErrors(null);
        //         this.phoneGrp.get('number').setErrors(null);
        //         errFields =[];
        //         this.phoneGrp.updateValueAndValidity();
        //     }
        // }

            let errorMsg = '';
            const showErrRequired = errFields.some(
                (err) => err.keyError === 'required'
            );
            const showErrPattern = errFields.some(
                (err) => err.keyError === 'pattern'
            );
            if (showErrRequired) {
                this.errorHeading = this.translate(
                    FrontEndErrMsgs.reqHeading,
                    { '0': '' },
                    ReturnType.HTML
                );
                this.errorMsgsReq = errFields.map((field) => {
                    return field.keyError == 'required'
                        ? this.translate(FrontEndErrMsgs[field.key])
                        : null;
                });
                this.errorMsgsReq.unshift(this.errorHeading);
                errorMsg = this.helperService.getErrorList(this.errorMsgsReq);
            } else if (showErrPattern) {
                this.errorHeading = this.translate(
                    'msg.cs816.text',
                    { '0': '' },
                    ReturnType.HTML
                );
                this.errorMsgsReq = errFields.map((field) => {
                    return field.keyError == 'pattern'
                        ? this.translate(FrontEndErrMsgs[field.key])
                        : null;
                });
                this.errorMsgsReq.unshift(this.errorHeading);
                errorMsg = this.helperService.getErrorList(this.errorMsgsReq);
            }
            if (errorMsg) {
                this.toasterService.error(errorMsg, null, {
                    enableHtml: true,
                    disableTimeOut: true,
                    tapToDismiss: false
                });
                return;
            }
        }

        // XSS/SQL-Injection validation - must be performed on every save attempt
        const securityFieldLabels = {
            'firstName': 'label.gb.firstname',
            'lastName': 'label.gb.lastname',
            'address': 'label.gb.address1',
            'address2': 'label.gb.address2',
            'address3': 'label.gb.address3',
            'state': 'label.gb.state_province',
            'city': 'label.gb.city',
            'zipCode': 'label.gb.zip_post_code',
            'phone.countryCode': 'label.gb.phone_country_code',
            'phone.areaCode': 'label.gb.phone_area_code',
            'phone.number': 'label.gb.home_phone'
        };

        if (!this.formSecurity.validateForm(this.emergencyForm, securityFieldLabels)) {
            return; // XSS/SQL threats found - validation service shows error
        }

        this.assignValues();
        this.emergencyContact = {
            ...this.emergencyContact,
            address: {
                ...this.emergencyContact.address,
                zipCode: this.emergencyContact.address.countryCd === 140 ? this.emergencyContact.address.zipCode?.replace(
                    /[^0-9\-]/g,
                    ''
                ) : this.emergencyContact.address.zipCode
            }
        }
        let update_contact: EmergencyContactModel = this.emergencyContact;
        //  update_contact.dropdowns = null;
        this.service
            .updateContactDetails(this.patientId, update_contact)
            .subscribe(
                (res) => {
                    this.toasterService.clear();
                    this.close();
                },
                (err) => {
                    if (err?.msgs && err?.msgs?.length > 0) {
                        let params;
                        let error;
                        if (err?.msgs[0]?.childs) {
                            params = err?.msgs[0]?.childs.map((child) => {
                                if (child?.msg !== 'label.gb.primary_phone') {
                                return this.translate(
                                    child.msg,
                                    {
                                        0: this.translate(
                                            err?.msgs[0]?.childs[0]?.msg,
                                            {},
                                            ReturnType.HTML
                                        ),
                                        1: this.translate(
                                            err?.msgs[0]?.childs[1]?.msg,
                                            {},
                                            ReturnType.HTML
                                        ),
                                    },
                                    ReturnType.HTML
                                );
                                } else {

                                    return this.translate('label.gb.phone');
                                }
                            });

                            error = this.translate(
                                err?.msgs[0]?.msg,
                                { '0': params.join('<br>') },
                                ReturnType.HTML
                            );
                        } else {
                            error = this.translate(
                                err?.msgs[0]?.msg,
                                {},
                                ReturnType.HTML
                            );
                        }
                        this.toasterService.error(error, null, {
                            enableHtml: true,
                            disableTimeOut: true,
                            tapToDismiss: false
                        });
                    }
                    if(err?.msgs[0]?.childs.map(((child: string)=> child==='label.gb.home_phone')))
                    {
                        this.phoneGrp.get('areaCode').setErrors({})
                        this.phoneGrp.get('countryCode').setErrors({})
                        this.phoneGrp.get('number').setErrors({})
                    }

                    this.emergencyForm.markAllAsTouched();
                }
            );
    }

    assignValues() {
        this.emergencyContact = {
            ...this.emergencyContact,
            firstName: this.emergencyForm.get('firstName').value,
            lastName: this.emergencyForm.get('lastName').value,
            notifyEmergencyContactFlg: this.emergencyForm.get(
                'notifyEmergencyContactFlg'
            ).value
                ? this.emergencyForm.get('notifyEmergencyContactFlg').value
                : false,
            address: {
                ...this.emergencyContact.address,
                address: this.emergencyForm.get('address').value,
                address2: this.emergencyForm.get('address2').value,
                address3: this.emergencyForm.get('address3').value,
                countryCd: this.emergencyForm.get('countryCd').value,
                stateCd: this.emergencyForm.get('stateCd').value,
                state_province: this.emergencyForm.get('state').value,
                state: this.emergencyForm.get('state').value,
                city: this.emergencyForm.get('city').value,
                zipCode: this.emergencyForm.get('zipCode').value,
            },
            phone: {
                ...this.emergencyContact.phone,
                areaCode: this.phoneGrp.get('areaCode').value?.replace(/[^0-9]/g, ''),
                countryCode: this.phoneGrp.get('countryCode').value?.replace(/[^0-9]/g, ''),
                number: this.phoneGrp.get('number').value?.replace(/[^0-9]/g, ''),
                phoneNum: this.phoneGrp.get('number').value?.replace(/[^0-9]/g, ''),
            },
            patientId: this.patientId,
        };
    }

    // errorHandling(controlItem, name) {

    //     if (controlItem && controlItem.errors) {
    //         this.isError = true;
    //         if (controlItem.errors?.required) {
    //             if (isControlRequired(controlItem)) {
    //                 // this.isError = true;
    //                 this.errorHeading ="";
    //                 this.errorHeading = this.translate(
    //                     FrontEndErrMsgs.reqHeading,
    //                     { '0': '' },
    //                     ReturnType.HTML
    //                 );
    //                 this.errorMsgsReq.push(
    //                     this.translate(FrontEndErrMsgs[name])
    //                 );
    //                 this.errorMsgsReq = Array.from(new Set(this.errorMsgsReq));
    //                 return;
    //             }
    //         } else if (controlItem.errors.pattern) {
    //             this.errorHeading ="";
    //             this.errorHeading = this.translate(
    //                 'msg.cs816.text',
    //                 { '0': '' },
    //                 ReturnType.HTML
    //             );
    //             this.errorMsgsInvalid.push(
    //                 this.translate(FrontEndErrMsgs[name], {}, ReturnType.HTML)
    //             );
    //             this.errorMsgsInvalid = Array.from(
    //                 new Set(this.errorMsgsInvalid)
    //             );
    //             return;
    //         }
    //     }
    // }
    getPatientDetails() {
        this.userService
            .getUserProfile(false)
            .pipe(
                tap((res) => res),
                switchMap((data: any) => {
                    this.userInfo = data;
                    return this.service.getExistingPatient(this.patientId);
                })
            )
            .subscribe((res) => {
                if (
                    res &&
                    res.patient &&
                    res.patient.firstName &&
                    res.patient.lastName
                ) {
                    if (
                        (this.userInfo && this.userInfo.locale.match('ja')) ||
                        this.userInfo.locale.match('zh')
                    ) {
                        this.patientName = `${res.patient.lastName} ${res.patient.firstName}`;
                    } else {
                        this.patientName = `${res.patient.firstName} ${res.patient.lastName}`;
                    }
                } else {
                    this.patientName = '';
                    this.patientIdForTitle = this.translate('label.gb.id', {
                        '0': res?.patient?.patientNum,
                    });
                }
            });
    }
    translate(key, param?: any, returnType: string = ReturnType.HTML) {
        return this.localizationService.generateLocalizedStr(
            key,
            param,
            returnType
        );
    }
    countrySelection(e) {
        this.emergencyForm.get('state').reset();
        this.emergencyForm.get('stateCd').reset();
        // if (!this.phoneGrp.get('countryCode').value) {
        this.lookupService.getDefaultCountryCode(e.value).subscribe((res) => {
            if (res) {
                this.phoneGrp
                    .get('countryCode')
                    .setValue(res.countryCallingCode);
                    if (e.value == 140 ) {
                        this.emergencyForm.get('zipCode').setValidators([Validators.maxLength(this.MAX_LENGTH_9), Validators.pattern(new RegExp(/^([^\d]*\d){5}(-?([^\d]*\d){4})?[^\d]*$/))]);

                    } else {
                        this.emergencyForm.get('zipCode').setValidators([Validators.maxLength(this.MAX_LENGTH_30)]);

                    }
                this.emergencyForm.get('zipCode').updateValueAndValidity();
            }
        });
        // }
    }
    onNotifyemrConFlgChange(evt) {
        this.togglePhone = evt.checked === true;

        this.emergencyForm
            .get('notifyEmergencyContactFlg')
            .setValue(this.togglePhone);
        if(this.togglePhone){
            this.phoneGrp.get('countryCode').setValidators([Validators.pattern(`^[0-9-,(), ' ', ., +]*$`), Validators.required]); //$,#,&,@,
            if (this.phoneGrp.get('countryCode').value == 1) {
                this.phoneGrp.get('areaCode').setValidators([Validators.pattern(`^[0-9-,(), ' ', ., +]*$`), Validators.required, Validators.maxLength(3)]) //$,#,&,@,
            } else {
                this.phoneGrp.get('areaCode').setValidators([Validators.pattern(`^[0-9-,(), ' ', ., +]*$`)]) //$,#,&,@,
            }
            this.phoneGrp.get('number').setValidators([Validators.pattern(`^[0-9-,(), ' ', ., +]*$`), Validators.required]) //$,#,&,@,

        }else{
            this.phoneGrp.get('countryCode').setValidators([Validators.pattern(`^[0-9-,(), ' ', ., +]*$`)]);  //$,#,&,@,
            this.phoneGrp.get('areaCode').setValidators([Validators.pattern(`^[0-9-,(), ' ', ., +]*$`)])  //$,#,&,@,
            this.phoneGrp.get('number').setValidators([Validators.pattern(`^[0-9-,(), ' ', ., +]*$`)]) //$,#,&,@,
        }
        this.phoneGrp.get('countryCode').updateValueAndValidity();
        this.phoneGrp.get('areaCode').updateValueAndValidity();
        this.phoneGrp.get('number').updateValueAndValidity();
    }
}
